import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.fill";
import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import BackTrack from "@/utils/backTrack";
import routerTempHelpers from "@/utils/routerTempHelpers";
import CalScreenFn from "@/utils/calScreenFn";
import Hammer from "hammerjs";
import html2canvas from "html2canvas";
import { recoverEditFilePath as _recoverEditFilePath } from "@/utils/fileFactory";
import nameBirthdayGender from "@/components/nameBirthdayGender/nameBirthdayGender.vue";
import { i18n } from "@/i18n/i18n-setup";
import { sendMapEvent } from "@/utils/analytics";
import { judgeIsIosAndIsNewCamera } from "@/utils/judgeVersion";
import { getBatch } from "@/utils/numUtils";

var ConfirmPhoto =
/*#__PURE__*/
function (_Vue) {
  _inherits(ConfirmPhoto, _Vue);

  function ConfirmPhoto() {
    var _this;

    _classCallCheck(this, ConfirmPhoto);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfirmPhoto).apply(this, arguments));
    _this.faceUrl = "";
    _this.goBackFunction = null;

    _this.nextStepFunction = function () {};

    _this.editFilePath = false; //是否要写入path

    _this.titleBarHeight = 44;
    _this.previewTopHeight = 80;
    _this.faceMaskHeight = 40;
    _this.handMaskHeight = 40;
    _this.START_X = 0;
    _this.START_Y = 0;
    _this.START_SCALE = 1;
    _this.START_ANGLE = 0;
    _this.hasEdit = false; //是否修改过原图

    _this.isShowHand = false;
    _this.defaultStyle = {
      transform: "translate3d(0,0,0)"
    };
    _this.scaningShow = false; //用来控制scaing

    _this.confirmShowScaning = false; //点击是否显示scaning

    _this.scaningAnimateSwitch = false;
    _this.iosNewScaningShow = true;
    _this.genderShow = false;
    _this.title = "";
    _this.childTitle = "";
    _this.functionType = null;
    _this.facePoints = null;
    _this.originFilePath = null;
    _this.ctx = null;
    _this.scaningText = i18n.t('confirm_photo.extracting_your_features');
    _this.defaultOptions = {
      animationData: require("@/assets/lottie/scanning_face_icon_animation.json")
    };
    _this.transform = {
      translate: {
        x: _this.START_X,
        y: _this.START_Y
      },
      scale: 1,
      angle: 0,
      rx: 0,
      ry: 0,
      rz: 1
    };
    return _this;
  }

  _createClass(ConfirmPhoto, [{
    key: "animateStart",
    value: function animateStart() {
      var _this2 = this;

      var row = 0;
      var line = 0;
      var width = 375;
      var height = 360;

      var changePosition = function changePosition() {
        if (!_this2.scaningAnimateSwitch) {
          return; //如果关闭显示 则不继续动画
        }

        row += 1;

        if (row !== 0 && row % 5 === 0) {
          line += 1;
          row = 0;
        }

        _this2.defaultStyle = {
          transform: "translate3d(".concat(-row * width, "px,").concat(-height * line, "px,0)")
        };

        if (line >= 5 && row % 5 === 0) {
          row = 0;
          line = 0;
          setTimeout(function () {
            changePosition();
          }, 1000);
          return;
        }

        setTimeout(function () {
          changePosition();
        }, 33);
      };

      changePosition();
    }
  }, {
    key: "clickClose",
    value: function clickClose() {
      if (this.scaningShow) {
        //正在扫描中
        return;
      }

      this.removeBackTrack();
      this.removeRouterTempQuery();

      if (this.goBackFunction !== null) {
        this.goBackFunction();
      } else {
        this.routerGoBack(-1);
      }
    }
  }, {
    key: "clickRotate",
    value: function clickRotate() {
      //旋转图片:
      this.transform.angle = this.transform.angle - 90;
      this.hasEdit = true;
    }
  }, {
    key: "screenshot",
    value: function () {
      var _screenshot = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var canvasEl, canvas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // const canvas = document.createElement("canvas");
                canvasEl = document.createElement("canvas"); //创建一个canvas节点

                canvasEl.getContext("2d");
                canvasEl.width = window.screen.width; //定义canvas 宽度 * 缩放

                canvasEl.height = window.screen.width / (375 / 302) + this.previewTopHeight * 2; //定义canvas高度 *缩放
                //获取context,设置scale

                _context.next = 6;
                return html2canvas(document.querySelector(".screen-shot-wrappe"), {
                  canvas: canvasEl,
                  backgroundColor: null,
                  scale: 1
                });

              case 6:
                canvas = _context.sent;
                return _context.abrupt("return", canvas.toDataURL("image/jpeg", 0.95));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function screenshot() {
        return _screenshot.apply(this, arguments);
      }

      return screenshot;
    }()
  }, {
    key: "recoverEditFilePath",
    value: function () {
      var _recoverEditFilePath2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(screenshot) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _recoverEditFilePath(screenshot);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function recoverEditFilePath(_x) {
        return _recoverEditFilePath2.apply(this, arguments);
      }

      return recoverEditFilePath;
    }()
  }, {
    key: "startShowScaning",
    value: function startShowScaning() {
      this.scaningShow = true; //显示扫描

      this.scaningAnimateSwitch = true; //动画开启

      this.animateStart(); //开始扫描动画

      this.hammerInstance.set({
        enable: false
      }); //禁止拖拽
    }
  }, {
    key: "clickConfirm",
    value: function () {
      var _clickConfirm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var factoryResult, screenshot, _factoryResult, filePath;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.confirmShowScaning && !this.isIosAndIsNewCamera) {
                  this.startShowScaning();
                }

                if (!this.isIosAndIsNewCamera) {
                  _context3.next = 7;
                  break;
                }

                factoryResult = {
                  base64: this.faceUrl.split(",")[1]
                };

                if (this.editFilePath) {
                  //写入path
                  factoryResult.filePath = this.originFilePath;
                } // 如果是需要选择内容的（包括手部扫描和personalFuture)


                if (this.title) {
                  this.childTitle = this.title;
                  this.factoryResult = factoryResult;
                  setTimeout(function () {
                    _this3.iosNewScaningShow = false;
                  }, 3000);
                } else {
                  //将处理的结果回传: {base64,filePath}
                  this.nextStepFunction(factoryResult);
                }

                _context3.next = 17;
                break;

              case 7:
                _context3.next = 9;
                return this.screenshot();

              case 9:
                screenshot = _context3.sent;
                _factoryResult = {
                  base64: screenshot.split(",")[1]
                };

                if (!this.editFilePath) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 14;
                return this.recoverEditFilePath(screenshot);

              case 14:
                filePath = _context3.sent;
                _factoryResult.filePath = filePath;

              case 16:
                // 如果是需要选择内容的（包括手部扫描和personalFuture)
                if (this.title) {
                  this.childTitle = this.title;
                  this.factoryResult = _factoryResult; //出现弹出框后扫描动画停止:

                  setTimeout(function () {
                    _this3.scaningAnimateSwitch = false; //关闭显示扫描
                  }, 3000);
                } else {
                  //将处理的结果回传: {base64,filePath}
                  this.nextStepFunction(_factoryResult);
                }

              case 17:
                if (this.functionType) {
                  sendMapEvent("uia_confirm_Palmistry", {
                    key: "confirm_click"
                  });
                }

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function clickConfirm() {
        return _clickConfirm.apply(this, arguments);
      }

      return clickConfirm;
    }()
  }, {
    key: "textChange",
    value: function textChange(fn) {
      var _this4 = this;

      var time1 = getBatch(500, 1200);
      setTimeout(function () {
        _this4.scaningText = i18n.t('confirm_photo.analyze_facial');
        var time2 = getBatch(1000, 1500);
        setTimeout(function () {
          _this4.scaningText = i18n.t('confirm_photo.generating_your_results');
          var time3 = getBatch(500, 1000);
          setTimeout(function () {
            fn && fn();
          }, time3);
        }, time2);
      }, time1);
    }
  }, {
    key: "getMyReport",
    value: function getMyReport(value) {
      this.factoryResult.value = value;
      this.nextStepFunction(this.factoryResult);
    }
  }, {
    key: "initData",
    value: function initData() {
      var queryTemp = routerTempHelpers.getQueryTemp(this.$route.query);

      if (queryTemp) {
        this.faceUrl = "data:image/jpeg;base64," + queryTemp.imageData.picUrl;
        this.facePoints = queryTemp.imageData.points;
        this.originFilePath = queryTemp.imageData.picFileUrl; //下一步的函数方法:

        this.nextStepFunction = queryTemp.nextStepFunction; //是否需要编辑写入到本地地址

        this.editFilePath = queryTemp.editFilePath;
        this.functionType = queryTemp.functionType;

        if (this.functionType) {
          sendMapEvent("uia_confirm_Palmistry", {
            key: "show"
          });
        } //返回逻辑


        if (queryTemp.goBackFunction) {
          this.goBackFunction = queryTemp.goBackFunction;
        } //是否展示手的


        this.isShowHand = queryTemp.isShowHand; //是否展示扫描的页面:

        this.confirmShowScaning = queryTemp.confirmShowScaning === null ? false : queryTemp.confirmShowScaning;
        queryTemp.title && (this.title = queryTemp.title);
        queryTemp.genderShow && (this.genderShow = queryTemp.genderShow);

        if (this.isIosAndIsNewCamera) {
          this.textChange(this.clickConfirm);
        }
      } else {
        this.faceUrl = "data:image/jpeg;base64," + this.$route.query.imageData.picUrl;
        this.nextStepFunction = this.$route.query.nextStepFunction;
        this.isShowHand = this.$route.query.isShowHand;
      }
    }
  }, {
    key: "drawPoints",
    value: function drawPoints() {
      var imgbox = document.querySelector(".new-camera-section .img-box");
      var imageDom = document.querySelector(".new-camera-section .origin-img");
      var cavs = document.querySelector(".point-canvas");
      var radio = imgbox.offsetWidth / imageDom.naturalWidth;

      if (cavs) {
        this.ctx = cavs.getContext("2d"); //获取画笔

        if (window.devicePixelRatio) {
          //清除canvas在移动端的锯齿
          cavs.style.width = imgbox.offsetWidth + "px";
          cavs.style.height = imgbox.offsetHeight + "px";
          cavs.width = imgbox.offsetWidth * window.devicePixelRatio;
          cavs.height = imgbox.offsetHeight * window.devicePixelRatio;
          this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(this.facePoints), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var j = _step.value;
            this.ctx.save();
            this.ctx.beginPath();
            this.ctx.fillStyle = "#fff";
            this.ctx.arc(j[0] * radio, j[1] * radio, 1, 0, 2 * Math.PI); //画圆

            this.ctx.fill();
            this.ctx.restore();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "addedBackTrack",
    value: function addedBackTrack() {
      var _this5 = this;

      //增加安卓返回键：
      BackTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this5.clickClose();
        }
      });
    }
  }, {
    key: "removeBackTrack",
    value: function removeBackTrack() {
      BackTrack.destroy(this.$route.name);
    }
  }, {
    key: "removeRouterTempQuery",
    value: function removeRouterTempQuery() {
      routerTempHelpers.destroyTempQuery(this.$route.query);
    }
  }, {
    key: "initCalHeight",
    value: function initCalHeight() {
      var CalScreenInstance = new CalScreenFn();
      this.titleBarHeight = CalScreenInstance.titleBarHeight;
      this.previewTopHeight = CalScreenInstance.previewTopHeight;
      this.faceMaskHeight = Math.round(CalScreenInstance.faceMaskHeight);
      this.handMaskHeight = Math.round(CalScreenInstance.handMaskHeight);
    }
  }, {
    key: "onPan",
    value: function onPan(ev) {
      // console.log("onPan:",ev);
      this.transform.translate = {
        x: this.START_X + ev.deltaX,
        y: this.START_Y + ev.deltaY
      };
      this.hasEdit = true;
    }
  }, {
    key: "onPinch",
    value: function onPinch(ev) {
      // console.log("onPinch:",ev);
      if (ev.type === "pinchstart") {
        this.START_SCALE = this.transform.scale || 1;
      }

      this.transform.scale = this.START_SCALE * ev.scale;
      this.hasEdit = true;
    }
  }, {
    key: "onRotate",
    value: function onRotate(ev) {
      if (ev.type === "rotatestart") {
        this.START_ANGLE = this.transform.angle || 0;
      }

      this.transform.rz = 1;
      this.transform.angle = this.START_ANGLE + ev.rotation;
    }
  }, {
    key: "initHammer",
    value: function initHammer() {
      var square = document.getElementById("query-mask"); // Create an instance of Hammer with the reference.

      this.hammerInstance = new Hammer.Manager(square, {
        domEvents: true
      });
      this.hammerInstance.add(new Hammer.Pan({
        threshold: 0,
        pointers: 0
      }));
      this.hammerInstance.add(new Hammer.Rotate({
        threshold: 0
      })).recognizeWith(this.hammerInstance.get("pan"));
      this.hammerInstance.add(new Hammer.Pinch({
        threshold: 0
      })).recognizeWith([this.hammerInstance.get("pan"), this.hammerInstance.get("rotate")]);
      this.hammerInstance.on("panstart panmove", this.onPan); // hammer.on("rotatestart rotatemove", this.onRotate);

      this.hammerInstance.on("pinchstart pinchmove", this.onPinch);
    }
  }, {
    key: "created",
    value: function created() {
      this.initCalHeight();
      this.initData();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this6 = this;

      window.StatusBar.styleLightContent();
      this.$nextTick(function () {
        if (!_this6.isIosAndIsNewCamera) {
          _this6.initHammer();
        } else {
          if (_this6.facePoints) {
            setTimeout(function () {
              _this6.drawPoints();
            }, 200);
          }

          ;
          var lottieContainer = document.querySelector('.lottie-container');

          if (lottieContainer && bodymovin) {
            bodymovin.loadAnimation({
              container: lottieContainer,
              renderer: 'svg',
              loop: true,
              autoplay: true,
              animationData: require("@/assets/lottie/scanning_face_icon_animation.json")
            });
          }
        }
      });
    }
  }, {
    key: "WatchRouteParma",
    value: function WatchRouteParma(val, oldVal) {
      if (val && oldVal && val.name === oldVal.name) {
        //避免跳转相同的路由不刷新数据
        this.initData();
      }
    }
  }, {
    key: "isIosAndIsNewCamera",
    get: function get() {
      return judgeIsIosAndIsNewCamera();
    }
  }, {
    key: "isIphoneX",
    get: function get() {
      return window.StatusBar.actualHeight === 44;
    }
  }, {
    key: "confirmTextInfo",
    get: function get() {
      return this.isShowHand ? i18n.t("common.camera.confirm_tips")[0] : i18n.t("common.camera.confirm_tips")[1];
    }
  }, {
    key: "hammerStyle",
    get: function get() {
      return {
        transform: "translate3d(".concat(this.transform.translate.x, "px,").concat(this.transform.translate.y, "px,0) scale(").concat(this.transform.scale, ",").concat(this.transform.scale, ") rotate3d(").concat(this.transform.rx, ",").concat(this.transform.ry, ",").concat(this.transform.rz, ",").concat(this.transform.angle, "deg)"),
        top: 0 + "px"
      };
    } //  375 / 302;

  }, {
    key: "screenshotStyle",
    get: function get() {
      return {
        height: window.screen.width / (375 / 302) + this.previewTopHeight * 2 + "px",
        top: 0 + "px"
      };
    }
  }]);

  return ConfirmPhoto;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], ConfirmPhoto.prototype, "routerPush", void 0);

tslib_1.__decorate([Action(types.AGEING_FORECAST)], ConfirmPhoto.prototype, "ageingForecast", void 0);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], ConfirmPhoto.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Watch("$route", {
  immediate: true
})], ConfirmPhoto.prototype, "WatchRouteParma", null);

ConfirmPhoto = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    nameBirthdayGender: nameBirthdayGender
  },
  name: "ConfirmPhoto"
})], ConfirmPhoto);
export default ConfirmPhoto;